var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-rich-text",domProps:{"innerHTML":_vm._s(_vm.nodes)},on:{"click":function($event){return _vm.replayImgShow($event)}}}),_c('community-preview',{attrs:{"show":_vm.show,"query":_vm.query},on:{"update:show":function($event){_vm.show=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }